export const pro = process.env.NODE_ENV !== 'development';
// export const pro = true;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1-0!./src/api/mode.ts